// Example: To understand how it works
import { ActionContext, ActionTree } from 'vuex';
import { DO_SOMETHING, SET_GENERAL_MEMBER_INFORMATION, SET_LOCATIONS_OF_MEMBER } from './mutation-types';
import { IGeneralInfoOfMember } from '../models/interfaces/iGeneralInfoOfMember'
import { ILocation } from '../models/interfaces/iLocation'
import State from './state';

// ActionTree<[current state], [root state]>
const actions: ActionTree<State, State> = {
    saveSometing({ commit }: ActionContext<State, State>, data: any): void {
        commit(DO_SOMETHING, data);
  },

  setGeneralInfomrationOfMember({ commit }: ActionContext<State, State>, data: IGeneralInfoOfMember): void {
    //debugger;

    commit(SET_GENERAL_MEMBER_INFORMATION, data);    
  },

  setLocationsOfMember({ commit }: ActionContext<State, State>, data: ILocation[]): void {
    //debugger;

    commit(SET_LOCATIONS_OF_MEMBER, data);
  }
};

export default actions;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/actions.ts